export default "__VITE_ASSET__DtVu3w3c__"